<template>
  <el-form ref="searchForm" :inline="true" :rules="rules" class="searchBoxLine" :model="searchForm">
    <el-form-item label="项目名称:" prop="projectName">
      <el-input v-model="searchForm.projectName" placeholder="请输入项目名称" />
    </el-form-item>
    <el-form-item label="合同编号:" prop="contractNum">
      <el-input v-model="searchForm.contractNum" placeholder="请输入合同编号" @blur="searchForm.contractNum = (searchForm.contractNum || '').trim()" />
    </el-form-item>
    <el-form-item label="代理商名称:" prop="distributorName">
      <el-input v-model="searchForm.distributorName" placeholder="请输入代理商名称" />
    </el-form-item>
    <el-form-item label="外销:" prop="salesManName">
      <el-input v-model="searchForm.salesManName" placeholder="请输入外销人员姓名" />
    </el-form-item>
    <el-form-item label="现销/赊销:" prop="salesType">
      <el-select v-model="searchForm.salesType" placeholder="请选择" clearable>
        <el-option v-for="option in salesTypeList" :key="option.name" :label="option.name" :value="option.code" />
      </el-select>
    </el-form-item>
    <el-form-item label="合同类型:" prop="contractType">
      <el-select v-model="searchForm.contractType" placeholder="请选择" clearable>
        <el-option v-for="option in contractType" :key="option.name" :label="option.name" :value="option.code" />
      </el-select>
    </el-form-item>

    <!--10.16 添加商务搜索条件-->
    <el-form-item v-if="isShowRegionBusiness" label="商务:" prop="regionBusinessCommissioner">
      <el-input v-model="searchForm.regionBusinessCommissioner" placeholder="请输入商务名称" />
    </el-form-item>

    <el-form-item v-if="isCustomerContractNum" label="客户合同编号:" prop="customerContractNum">
      <el-input v-model="searchForm.customerContractNum" placeholder="请输入项目名称" />
    </el-form-item>
    <el-form-item label="付款时间:" prop="createBeginTime">
      <div class="rj-flex">
        <div class="rj-flex__item">
          <el-date-picker
            v-model="searchForm.createBeginTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </div>
        <div style="display: inline-block;width: 10px;text-align: center">
          -
        </div>
        <div class="rj-flex__item">
          <el-date-picker
            v-model="searchForm.createEndTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          />
        </div>
      </div>
    </el-form-item>
    <el-form-item v-if="isOrderStatus" label="最后处理时间:" prop="startFinalProcessingTime">
      <div class="rj-flex">
        <div class="rj-flex__item">
          <el-date-picker
            v-model="searchForm.startFinalProcessingTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </div>
        <div style="display: inline-block;width: 10px;text-align: center">
          -
        </div>
        <div class="rj-flex__item">
          <el-date-picker
            v-model="searchForm.endFinalProcessingTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            :picker-options="pickerOptions2"
          />
        </div>
      </div>
    </el-form-item>
    <el-form-item label="分配比例:" prop="endDistributionRatio">
      <div class="rj-flex">
        <div class="rj-flex__item">
          <el-input-number v-model.trim="searchForm.startDistributionRatio" :precision="2" :min="0" :max="100" placeholder="分配比例" :controls="false" />
        </div>
        <div style="display: inline-block;width: 10px;text-align: center">
          -
        </div>
        <div class="rj-flex__item">
          <el-input-number v-model.trim="searchForm.endDistributionRatio" :precision="2" :min="0" :max="100" placeholder="分配比例" :controls="false" />
        </div>
      </div>
    </el-form-item>
    <el-form-item label="预付款比例:">
      <div class="rj-flex">
        <div class="rj-flex__item">
          <el-input-number v-model.trim="searchForm.startAdvanceCharge" :precision="2" :min="0" :max="100" placeholder="预付款比例" :controls="false" />
        </div>
        <div style="display: inline-block;width: 10px;text-align: center">
          -
        </div>
        <div class="rj-flex__item">
          <el-input-number v-model.trim="searchForm.endAdvanceCharge" :precision="2" :min="0" :max="100" placeholder="预付款比例" :controls="false" />
        </div>
      </div>
    </el-form-item>
    <el-form-item label="部门:" prop="departmentName">
      <el-input v-model="searchForm.departmentName" placeholder="请选择部门" />
    </el-form-item>
    <el-form-item label="区域:" prop="regionName">
      <el-input v-model="searchForm.regionName" placeholder="请选择区域" />
    </el-form-item>
    <el-form-item v-if="isOrderStatus" label="是否自动化:" prop="isOrderAutoPassing">
      <el-select v-model="searchForm.isOrderAutoPassing" placeholder="请选择" clearable>
        <el-option v-for="option in isOrderAutoList" :key="option.name" :label="option.name" :value="option.code" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" :loading="Loading" @click="doSearch">
        搜索
      </el-button>
      <el-button type="default" @click="resetForm">
        重置
      </el-button>
    </el-form-item>
  </el-form>
</template>
<script type="es6">
import { mapState } from 'vuex';
export default {
  data () {
    var isBig = (rule, value, callback) => {
      if (value <= this.searchForm.startDistributionRatio) {
        callback(new Error('分配比例结束条件不能小于等于起始条件!'));
      } else {
        callback();
      }
    };
    return {
      Loading: false,
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.createBeginTime) {
            let date = new Date(this.searchForm.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.searchForm.startFinalProcessingTime) {
            let date = new Date(this.searchForm.startFinalProcessingTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      rules: {
        endDistributionRatio: [
          { validator: isBig, trigger: 'blur' }
        ]
      }
    };
  },
  model: {
    prop: 'searchForm',
    event: 'change'
  },
  props: {
    isOrderStatus: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isCustomerContractNum: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    searchForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isShowRegionBusiness: {
      type: Boolean,
      default: () => false
    }
  },
  components: {},
  computed: {
    ...mapState({
      salesTypeList: state => state.enumeration.salesTypeList, //  现销/赊销
      contractType: state => state.enumeration.contractType,
      isOrderAutoList: state => state.enumeration.isOrderAutoList
    })
  },
  methods: {
    doSearch () {
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          this.Loading = true;
          this.$emit('submit', '', (res) => {
            this.Loading = res;
          });
        } else {
          return false;
        }
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createEndTime = '';
      this.searchForm.endFinalProcessingTime = '';
      this.searchForm.startDistributionRatio = '';
      this.searchForm.startAdvanceCharge = '';
      this.searchForm.endAdvanceCharge = 100;
      this.doSearch();
    }
  },
  mounted () {
  }
};
</script>
<style lang="less"></style>
